export { default as ConnectedInfiniteTable } from "./ConnectedInfiniteTable";
export { default as SearchConnectedInfiniteTable } from "./SearchConnectedInfiniteTable";
